"use client";

import { c as _c } from "react/compiler-runtime";
import { nanoid } from "nanoid";
import { useState } from "react";
import { useFormStatus } from "react-dom";
import { capitalize } from "@/lib/utils";
import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import { asyncDebounce, debounce } from "@/ui/hooks/use-debounced-value";
import { Button } from "@/ui/shadcn/button";
import { Label } from "@/ui/shadcn/label";
import { Switch } from "@/ui/shadcn/switch";
import { StatefulInput } from "@/ui/stateful-input";
import { TailwindColorPicker } from "@/ui/tailwind-color-picker";
import { MenuEditor } from "../nav/menu-editor";
import { FooterPaymentMethods, FooterSocialItems } from "./footer-sections";
const debouncedSaveSections = asyncDebounce((context, sections) => {
  return context.saveSelectedPageSectionField({
    fieldPath: "sections",
    value: sections
  });
}, 300);
export const FooterForm = t0 => {
  const $ = _c(68);
  const {
    data,
    theme
  } = t0;
  let t1;
  if ($[0] !== data.sections) {
    t1 = data.sections ?? [];
    $[0] = data.sections;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [sections, setSections] = useState(t1);
  const context = useStoreBuilderContext();
  useFormStatus();
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-sm font-semibold text-neutral-900 mb-3 pb-2 border-b border-neutral-200">Display Options</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = data.credits ?? false;
  let t4;
  if ($[3] !== context) {
    t4 = value => {
      context.saveSelectedPageSectionField({
        fieldPath: "credits",
        value
      });
    };
    $[3] = context;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <Switch defaultChecked={t3} name="credits" onCheckedChange={t4} />;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-sm font-medium text-neutral-900">Show credits</span>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5) {
    t7 = <Label className="flex items-center gap-2">{t5}{t6}</Label>;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = data.newsletterVisible ?? false;
  let t9;
  if ($[11] !== context) {
    t9 = value_0 => {
      context.saveSelectedPageSectionField({
        fieldPath: "newsletterVisible",
        value: value_0
      });
    };
    $[11] = context;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8 || $[14] !== t9) {
    t10 = <Switch defaultChecked={t8} name="newsletterVisible" onCheckedChange={t9} />;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="text-sm font-medium text-neutral-900">Show newsletter</span>;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10) {
    t12 = <Label className="flex items-center gap-2">{t10}{t11}</Label>;
    $[17] = t10;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t7) {
    t13 = <div>{t2}<div className="space-y-4">{t7}{t12}</div></div>;
    $[19] = t12;
    $[20] = t7;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="text-sm font-semibold text-neutral-900 mb-3 pb-2 border-b border-neutral-200">Social Media</div>;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== context || $[24] !== data.socials) {
    t15 = Object.entries(FooterSocialItems).map(t16 => {
      const [key, social] = t16;
      const IconComponent = social.icon;
      return <Label className="grid gap-1" key={key}><span className="text-xs text-neutral-600 font-medium">{capitalize(key)}</span><div className="flex"><div className="flex items-center justify-center w-8 h-8 bg-neutral-50 border border-r-0 border-neutral-200 rounded-l-sm"><IconComponent className="w-3.5 h-3.5 text-neutral-600" /></div><StatefulInput defaultValue={data.socials?.[key]} name={`socials.${key}`} placeholder={`Your ${social.name} handle`} className="rounded-l-none flex-1 h-8 text-sm" onBlur={async e => {
            const value_1 = e.currentTarget.value;
            if (value_1 === data.socials?.[key]) {
              return;
            }
            if (!data.socials) {
              await context.saveSelectedPageSectionField({
                fieldPath: "socials",
                value: {}
              });
            }
            await context.saveSelectedPageSectionField({
              fieldPath: `socials.${key}`,
              value: value_1
            });
          }} data-1p-ignore={true} autoComplete="off" /></div></Label>;
    });
    $[23] = context;
    $[24] = data.socials;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t15) {
    t16 = <div>{t14}<div className="space-y-2">{t15}</div></div>;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="text-sm font-semibold text-neutral-900 mb-3 pb-2 border-b border-neutral-200">Payment Methods</div>;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== context || $[30] !== data.paymentMethods) {
    t18 = Object.entries(FooterPaymentMethods).map(t19 => {
      const [key_0, payment] = t19;
      const IconComponent_0 = payment.icon;
      return <Label className="flex items-center gap-2 cursor-pointer" key={key_0}><Switch defaultChecked={data.paymentMethods?.[key_0] ?? false} onCheckedChange={async checked => {
          if (!data.paymentMethods) {
            await context.saveSelectedPageSectionField({
              fieldPath: "paymentMethods",
              value: {}
            });
          }
          await context.saveSelectedPageSectionField({
            fieldPath: `paymentMethods.${key_0}`,
            value: checked
          });
        }} /><div className="flex items-center gap-2"><IconComponent_0 className="size-5 rounded-xs" /><span className="text-xs text-neutral-600 font-medium">{payment.name}</span></div></Label>;
    });
    $[29] = context;
    $[30] = data.paymentMethods;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t18) {
    t19 = <div>{t17}<div className="grid grid-cols-2 gap-3">{t18}</div></div>;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="text-sm font-semibold text-neutral-900 mb-3 pb-2 border-b border-neutral-200">Theme Settings</div>;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span className="text-xs text-neutral-600 font-medium">Background Color</span>;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  const t22 = theme.backgroundColor;
  let t23;
  if ($[36] !== context) {
    t23 = debounce(value_2 => {
      context.saveSelectedPageSectionThemeField({
        fieldPath: "backgroundColor",
        value: value_2
      });
    }, 300, {
      trailing: true
    });
    $[36] = context;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== t23 || $[39] !== theme.backgroundColor) {
    t24 = <Label className="grid gap-1">{t21}<TailwindColorPicker defaultValue={t22} onValueChange={t23} /></Label>;
    $[38] = t23;
    $[39] = theme.backgroundColor;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <span className="text-xs text-neutral-600 font-medium">Text Color</span>;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  const t26 = theme.color;
  let t27;
  if ($[42] !== context) {
    t27 = debounce(value_3 => {
      context.saveSelectedPageSectionThemeField({
        fieldPath: "color",
        value: value_3
      });
    }, 300, {
      trailing: true
    });
    $[42] = context;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] !== t27 || $[45] !== theme.color) {
    t28 = <Label className="grid gap-1">{t25}<TailwindColorPicker defaultValue={t26} onValueChange={t27} /></Label>;
    $[44] = t27;
    $[45] = theme.color;
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  if ($[47] !== t24 || $[48] !== t28) {
    t29 = <div>{t20}<div className="grid gap-4 lg:grid-cols-2">{t24}{t28}</div></div>;
    $[47] = t24;
    $[48] = t28;
    $[49] = t29;
  } else {
    t29 = $[49];
  }
  let t30;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <div className="text-sm font-semibold text-neutral-900 mb-3 pb-2 border-b border-neutral-200">Links</div>;
    $[50] = t30;
  } else {
    t30 = $[50];
  }
  let t31;
  if ($[51] !== context || $[52] !== sections) {
    t31 = sections?.map((section, sectionIndex) => <div key={sectionIndex + "_" + sections.length} className="space-y-4"><div className="relative"><Button variant="link" className="p-0 text-destructive/50 hover:text-destructive absolute right-0 -top-3" type="button" onClick={() => {
          const newSections = sections.filter((_, i) => i !== sectionIndex);
          setSections(newSections);
          debouncedSaveSections(context, newSections);
        }}>Remove</Button><Label className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Section {sectionIndex + 1} header</span><StatefulInput defaultValue={section.header} name={`sections.${sectionIndex}.header`} onValueChange={debounce(value_4 => {
            const newSections_0 = sections.map((section_0, idx) => idx === sectionIndex ? {
              ...section_0,
              header: value_4
            } : section_0);
            setSections(newSections_0);
            debouncedSaveSections(context, newSections_0);
          }, 300, {
            trailing: true
          })} /></Label></div><MenuEditor onChange={item => {
        const newSections_1 = sections.map((section_1, idx_0) => idx_0 === sectionIndex ? {
          ...section_1,
          links: item
        } : section_1);
        setSections(newSections_1);
        debouncedSaveSections(context, newSections_1);
      }} allowedTypes={["custom", "category", "collection", "custom", "static"]} items={section.links?.map(_temp) ?? []} /></div>);
    $[51] = context;
    $[52] = sections;
    $[53] = t31;
  } else {
    t31 = $[53];
  }
  let t32;
  if ($[54] !== t31) {
    t32 = <div className="space-y-6">{t31}</div>;
    $[54] = t31;
    $[55] = t32;
  } else {
    t32 = $[55];
  }
  let t33;
  if ($[56] !== context || $[57] !== sections) {
    t33 = <Button type="button" variant="outline" size="sm" onClick={() => {
      const newSections_2 = [...sections, {
        header: "",
        links: [{
          label: "",
          href: ""
        }]
      }];
      setSections(newSections_2);
      debouncedSaveSections(context, newSections_2);
    }}>Add section</Button>;
    $[56] = context;
    $[57] = sections;
    $[58] = t33;
  } else {
    t33 = $[58];
  }
  let t34;
  if ($[59] !== t32 || $[60] !== t33) {
    t34 = <div>{t30}{t32}{t33}</div>;
    $[59] = t32;
    $[60] = t33;
    $[61] = t34;
  } else {
    t34 = $[61];
  }
  let t35;
  if ($[62] !== t13 || $[63] !== t16 || $[64] !== t19 || $[65] !== t29 || $[66] !== t34) {
    t35 = <div className="space-y-6 relative pb-20">{t13}{t16}{t19}{t29}{t34}</div>;
    $[62] = t13;
    $[63] = t16;
    $[64] = t19;
    $[65] = t29;
    $[66] = t34;
    $[67] = t35;
  } else {
    t35 = $[67];
  }
  return t35;
};
function _temp(link) {
  if (!("type" in link)) {
    return {
      id: nanoid(),
      type: "custom",
      label: link.label ?? "",
      url: link.href ?? ""
    };
  }
  return link;
}